import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiAdminCabService } from 'src/app/services/api/admin/admin-cab/admin-cab.service';

@Component({
  selector: 'app-cab-member-removal-dialog-component',
  templateUrl: './cab-member-removal-dialog-component.component.html',
  styleUrls: ['./cab-member-removal-dialog-component.component.css']
})
export class CabMemberRemovalDialogComponentComponent implements OnInit {
  @Input() data: any; 
  @Output() remove = new EventEmitter<any>();

  userName: string = '';
  requestIds: number[] = [];
  isLoading = true;
  cabId: number; 

  constructor(
      private apiAdminCabService: ApiAdminCabService
  ) {}

  ngOnInit(): void {
      const user = this.data?.user;
      this.cabId = this.data?.cabId; 
      if (user) {
          this.userName = user.Name;
          this.fetchRequestIdsForUser(user.Id);
      }
  }

  fetchRequestIdsForUser(userId: number) {
      this.apiAdminCabService.getRequestsForCabMember(userId, this.cabId).then(
          (response: any) => {
              this.requestIds = response.requestIds || [];
              this.isLoading = false;
          },
          (error) => {
              this.requestIds = [];
              this.isLoading = false;
          }
      );
  }

  closeModal() {
    this.remove.emit(null);
  }

  save() {
    this.remove.emit(true);
  }
}